import { hasModuleAccess, getMissingFeatures } from '@m3-tech/boss-utils'
import { FEATURE_COMMUNICATIONS_MODERNIZATION } from '@/types/module.types'

export const REQUIRED_MODULE_FEATURES = [FEATURE_COMMUNICATIONS_MODERNIZATION] as const

export function hasModuleFeatureAccess(userFeatures: number[]): boolean {
    return hasModuleAccess(userFeatures, REQUIRED_MODULE_FEATURES)
}

export function getMissingModuleFeatures(userFeatures: number[]): number[] {
    return getMissingFeatures(userFeatures, REQUIRED_MODULE_FEATURES)
}
